@if (isLoading()) {
    <div class="main-content mb-4 mx-lg-4 mx-md-4 mx-sm-0 px-sm-4 px-3">
        <ms-page-title />

        <div class="d-flex justify-content-center align-items-center py-5">
            <span class="spinner-border text-primary me-3" role="status" aria-label="Loading invoice schedule"></span>
            <span>Loading invoice schedule...</span>
        </div>
    </div>
} @else if (schedule()) {
    <ms-charge-schedule-form
        [formState]="FormState.Update"
        [scheduleData]="schedule()"
        [openInvoicesCount]="openInvoicesCount()" />
}
